// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","MenuItem":"MenuItem_hh43d","MenuItemText":"MenuItemText_pl75Q"};